module.exports = __webpack_public_path__ + "static/media/search.3342aa32.png";